import { gray } from '@ant-design/colors';
import { HomeOutlined } from '@ant-design/icons';
import { Breadcrumb, Tooltip } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { FunctionComponent, useMemo } from 'react';
import { capitalCase } from 'change-case';
import { useTenantBasepath } from 'packages/lib/auth/is-path';

export const Breadcrumbs: FunctionComponent<
  React.PropsWithChildren<unknown>
> = () => {
  const { pathname } = useLocation();
  const pathParts = pathname.split('/').slice(1);

  const basePath = useTenantBasepath();

  const breadcrumbItems = useMemo(() => {
    return [
      {
        key: '/',
        title: (
          <Tooltip title="Go home">
            <Link
              to={basePath}
              style={{
                color: gray[1],
              }}
            >
              <HomeOutlined style={{ marginRight: '0.25rem' }} />
            </Link>
          </Tooltip>
        ),
      },
      ...pathParts.map((part, i) => ({
        key: `/${part}`,
        title: (
          <Tooltip title={part} key={`path-${part}`}>
            <Link
              style={{ color: 'white' }}
              to={`/${pathParts.slice(0, i + 1).join('/')}`}
            >
              {capitalCase(part.replace('-', ' '))}
            </Link>
          </Tooltip>
        ),
      })),
    ];
  }, [basePath, pathParts]);
  return (
    <div
      style={{
        marginLeft: '1.75rem',
        color: gray[2],
        fontSize: '1rem',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Breadcrumb
        items={breadcrumbItems}
        separator={
          <span style={{ color: gray[1], margin: '0 0.5rem' }}>/</span>
        }
      />
    </div>
  );
};
